import React, { useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Select, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";

export default function TimePickerValue(Props) {
  const { handleTime, slots } = Props;
  const [def, setDef] = useState("");
  const STATE = useSelector((state) => state?.auth?.userdata);
  const [selValue, setValue] = useState();

  useEffect(() => {
    setDef(STATE?.Date ? "Select Time" : "Please Select Date First");
  }, [STATE?.Date]);

  useEffect(() => {
    if (STATE?.Time === "") setValue("");
  }, [STATE?.Time]);

  useEffect(() => {
    if (selValue) handleTime(selValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selValue]);
  return (
    <FormControl fullWidth sx={{ mt: 0 }}>
      <Select
        value={selValue || ""}
        displayEmpty
        fullWidth
        sx={{
          "& .MuiSelect-select": {
            fontSize: 16,
            py: 1.5,
          },
        }}
        renderValue={(value) => {
          return (
            <Box sx={{ display: "flex", gap: 1, width: "100%", alignItems: "center" }}>
              <AccessTimeIcon fontSize="small" />
              {selValue ? value : def}
            </Box>
          );
        }}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      >
        {slots.length ? (
          slots.map((option) => (
            <MenuItem
              key={option}
              value={option}
              // eslint-disable-next-line eqeqeq
              disabled={option == "No Data Found" ? true : false}
            >
              {option}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" disabled={true}>
            {"No Data Found"}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
